import { Action } from '@ngrx/store';
import { BrandInfoState } from './brand-info.state';

export enum BrandInfoActionTypes {
  LOAD_BRAND_INFO_CONTENT = '[BrandPLP] BrandInfo Load',
  LOAD_BRAND_INFO_CONTENT_SUCCESS = '[BrandPLP] BrandInfo Load Success',
  LOAD_BRAND_INFO_CONTENT_FAILURE = '[BrandPLP] BrandInfo Load Failure',
  RESET_BRAND_INFO = '[BrandPLP] Reset BrandInfo'
}

export class LoadBrandInfoContent implements Action {
    readonly type = BrandInfoActionTypes.LOAD_BRAND_INFO_CONTENT;

    constructor(public payload: string) {}
}

export class LoadBrandInfoContentSuccess implements Action {
    readonly type = BrandInfoActionTypes.LOAD_BRAND_INFO_CONTENT_SUCCESS;

    constructor(public payload: { response: BrandInfoState} ) {
    }
}

export class LoadBrandInfoContentFailure implements Action {
    readonly type = BrandInfoActionTypes.LOAD_BRAND_INFO_CONTENT_FAILURE;

    constructor(public payload: {error: any}) {
    }
}

export class ResetBrandInfo implements Action {
  readonly type = BrandInfoActionTypes.RESET_BRAND_INFO;

  constructor() {}
}

export type BrandInfoActionsUnion = LoadBrandInfoContent
| LoadBrandInfoContentSuccess
| LoadBrandInfoContentFailure
| ResetBrandInfo;
